/**
 * A stable key for what a date-range filter selects (a named period, or a start/end pair), so two
 * filters can be compared by value: DateRangePicker hands out a new object on every emit, including
 * one equal to the filter the parent already holds.
 */
export const dateRangeKey = (filter) =>
  JSON.stringify([filter?.period ?? null, filter?.start_date ?? null, filter?.end_date ?? null]);

export const isSameDateRange = (a, b) => dateRangeKey(a) === dateRangeKey(b);
